import {Component, Input, OnInit} from '@angular/core';
import {
  BerlinBrandenburgBerichtTag,
  BrandenburgLangBericht, LangWetterVorhersagen,
} from "../../../../../../../../model/vorhersagen/rbb-document";

@Component({
  selector: 'app-brandenburg-lang-bericht',
  templateUrl: './brandenburg-lang-bericht.component.html',
  styleUrls: ['./brandenburg-lang-bericht.component.css', '../../../wetterbericht.component.css']
})
export class BrandenburgLangBerichtComponent{


  langWetterAussichtenTageMitNaechte: LangWetterAussichtTagMitNacht[];
  langWetterVorhersage: LangWetterVorhersagen;

  @Input()
  set brandenburgLangBericht(brandenburgLangBericht: BrandenburgLangBericht) {
    this.langWetterVorhersage = brandenburgLangBericht?.langwetterVorhersage;
    const aussichten = brandenburgLangBericht?.langwetterAussichten;
    this.langWetterAussichtenTageMitNaechte = [new LangWetterAussichtTagMitNacht(aussichten?.tag02, aussichten?.nachtZuTag02)]
    this.langWetterAussichtenTageMitNaechte.push(new LangWetterAussichtTagMitNacht(aussichten?.tag03, aussichten?.nachtZuTag03))
    this.langWetterAussichtenTageMitNaechte.push(new LangWetterAussichtTagMitNacht(aussichten?.tag04, aussichten?.nachtZuTag04))
    this.langWetterAussichtenTageMitNaechte.push(new LangWetterAussichtTagMitNacht(aussichten?.tag05, aussichten?.nachtZuTag05))
    this.langWetterAussichtenTageMitNaechte.push(new LangWetterAussichtTagMitNacht(aussichten?.tag06, aussichten?.nachtZuTag06))
  }
}

class LangWetterAussichtTagMitNacht {
  tag: BerlinBrandenburgBerichtTag;
  nachtZuTag: BerlinBrandenburgBerichtTag;

  constructor(tag: BerlinBrandenburgBerichtTag, nachtZuTag: BerlinBrandenburgBerichtTag) {
    this.tag = tag;
    this.nachtZuTag = nachtZuTag;
  }
}
